module.exports = __webpack_public_path__ + "img/g_a_ua.2871aa58.gif";